// This file is not run normally, it's only used as a hook for
// extract-text-plugin. Don't actually put any code in this file.
const lessRequire = require.context(".", true, /\.less$/);
const useableRegex = /\.lazy\.less$/;
lessRequire
  .keys()
  .filter(filename => !useableRegex.test(filename))
  .forEach(filename => lessRequire(filename));
